<div class="chat-bot-container" [class.expanded]="isExpanded()">
  <div class="backdrop" *ngIf="chatBotService.isLeftPanelOpen()" (click)="closeLeftPanel()"></div>
  <!-- Chat Header -->
  <miq-chat-bot-header
    [showMenuBtn]="true"
    [isInprogress]="isResponseInProgress() || isHistoryLoading()"
    (emitCloseChat)="closeChat()"
    [windowSizeIncreased]="isExpanded()"
    (emitWindowSize)="toggleWindowSize()"
    (emitNewSession)="startNewSession()"
  ></miq-chat-bot-header>

  <div class="chat-bot-left-panel" [class.hidden]="!chatBotService.isLeftPanelOpen()">
    <miq-chat-left-panel
      (emitNewSession)="startNewSession()"
      [chatHistory]="chatHistory"
      (emitSelectedSession)="loadSavedSession($event)"
    ></miq-chat-left-panel>
  </div>

  <!-- Chat Body -->
  <div class="chat-bot-body" #chatBody>
    <div class="greeting-section" *ngIf="!(sessionId() || isHistoryLoading())">
      <div class="greeting-title">Hey {{ userInfo?.firstName }},</div>
      <div class="greeting-subtitle">
        <p>{{ 'chat.askMeAnything' | xTranslate }}</p>
      </div>
    </div>
    <!--Default Prompts-->
    <div class="default-prompts" *ngIf="!(sessionId() || isHistoryLoading())">
      <ng-container *ngFor="let prompt of defaultPrompts">
        <div class="default-prompt" [class.expanded]="isExpanded()" (click)="handlePromptClick(prompt)">
          {{ prompt }}
        </div>
      </ng-container>
    </div>

    <div class="conversation-section">
      <ng-container *ngIf="isHistoryLoading(); else content">
        <cbre-spinner-loading-indicator
          diameter="48"
          [description]="'loading' | xTranslate"
        ></cbre-spinner-loading-indicator>
      </ng-container>
      <ng-template #content>
        <ng-container *ngFor="let msg of messages(); let i = index">
          <miq-chat-conversation
            [message]="msg"
            [index]="i"
            (emitFeedback)="updateMessage($event, i)"
          ></miq-chat-conversation>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <!-- Chat Input -->
  <div class="chat-input-section">
    <miq-chat-input
      #chatInput
      (sendMessage)="handleUserMessage($event)"
      [(message)]="chatInputValue"
      [isResponseInProgress]="isResponseInProgress() || isHistoryLoading()"
      (messageChange)="onMessageChange($event)"
    ></miq-chat-input>
  </div>
  <div
    class="chat-bot-prompts-panel"
    [class.hidden]="!chatBotService.isPromptsPanelOpen()"
    [class.expanded]="isExpanded()"
  >
    <miq-chat-prompts-panel
      [defaultPrompts]="defaultGroupByPrompts"
      [windowSizeIncreased]="isExpanded()"
      (emitPromptSelected)="handlePromptClick($event)"
      (emitToggleWindowSize)="togglePromptsWindowSize()"
      (emitStartNewSession)="startNewSession()"
    >
    </miq-chat-prompts-panel>
  </div>
</div>
